import React from "react";

const InvalidateNoteForm = ({ onSubmit, onCancel }) => {
	const reasonRef = React.createRef();
	return (
		<form
			method="POST"
			onSubmit={event => {
				event.preventDefault();
				onSubmit({
					reason: reasonRef.current.value
				});
				reasonRef.current.value = "";
			}}
		>
			<div className="form-group">
				<label htmlFor="reason-id">Reason</label>
				<input
					type="text"
					className="form-control input-height"
					id="reason-id"
					required
					ref={reasonRef}
					aria-describedby="reason-id"
					placeholder="enter reason"
				/>
				<small id="reason-id" className="form-text text-muted">
					Reason for Invalidating care note.
				</small>
			</div>

			<div className="text-center">
				<button
					type="button"
					onClick={onCancel}
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-default"
				>
					<i className="material-icons text-danger">cancel</i> Cancel
				</button>
				<button
					type="submit"
					className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  btn-circle btn-success"
				>
					Invalidate Note <i className="material-icons">arrow_right_alt</i>
				</button>
			</div>
		</form>
	);
};

export default InvalidateNoteForm;
